import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const registeredNodeTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Registered Nodes',
  key: 'registeredNodes',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['siteName', 'nodeName', 'nodeType'],
          ['topology', 'ipAddr', 'ipAddr6'],
          ['status', 'swVersion', '$empty'],
          ['location', '$empty', '$empty'],
          ['country', 'stateName', 'city'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      ipAddr: {
        label: 'IPv4 Address',
        type: 'text',
        initial: '0.0.0.0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      ipAddr6: {
        label: 'IPv6 Address',
        type: 'text',
        initial: '::',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      status: {
        label: 'Status',
        type: 'select',
        initial: 'ACTIVE',
        options: [
          {
            label: 'ACTIVE',
            value: 'ACTIVE'
          },
          {
            label: 'PARTIAL',
            value: 'PARTIAL'
          },
          {
            label: 'INACTIVE',
            value: 'INACTIVE'
          },
          {
            label: 'FAILED',
            value: 'FAILED'
          },
          {
            label: 'LEADER',
            value: 'LEADER'
          }
        ],
      },
      swVersion: {
        label: 'Software Version',
        type: 'text',
        initial: '',
      },
      nodeName: {
        label: 'Node Name',
        type: 'text',
        initial: '',
      },
      siteName: {
        label: 'Site Name',
        type: 'text',
        initial: '',
      },
      nodeType: {
        label: 'Node Type',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select a node type',
            value: ''
          },
          {
            label: 'XCF3',
            value: 'XCF3'
          },
          {
            label: 'XCP',
            value: 'XCP'
          },
          {
            label: 'XTP',
            value: 'XTP'
          },
          {
            label: 'XDP',
            value: 'XDP'
          },
          {
            label: 'INF3',
            value: 'INF3'
          },
          {
            label: 'SEGW',
            value: 'SEGW'
          },
          {
            label: 'XCP_XMS',
            value: 'XCP_XMS'
          },
          {
            label: 'XMS_XCDB',
            value: 'XMS_XCDB'
          },
          {
            label: 'MDF2',
            value: 'MDF2'
          },
          {
            label: 'MDF3',
            value: 'MDF3'
          },
          {
            label: 'CCPAG',
            value: 'CCPAG'
          },
          {
            label: 'XCRDD',
            value: 'XCRDD'
          },
          {
            label: 'XCID',
            value: 'XCID'
          },
          {
            label: 'ADMF',
            value: 'ADMF'
          },
          {
            label: 'XCLOC',
            value: 'XCLOC'
          }
        ],
      },
      topology: {
        label: 'Topology',
        type: 'select',
        initial: 'STANDALONE',
        validation: {
          required: true
        },
        options: [
          {
            label: 'STANDALONE',
            value: 'STANDALONE'
          },
          {
            label: 'HAPAIR',
            value: 'HAPAIR'
          }
        ]
      },
      location: {
        type: 'custom',
        initial: 'Location',
        customComponent: 'certificate',
        className: 'section-label',
      },
      country: {
        label: 'Country',
        type: 'select',
        initial: '',
        validation: {
          required: false
        },
        options: [
          {
            label: 'Select a country',
            value: ''
          }
        ],
      },
      stateName: {
        label: 'State/Province',
        type: 'select',
        initial: '',
        disabled: true,
        validation: {
          required: false
        },
        options: [
          {
            label: 'Select a state/province',
            value: ''
          }
        ],
      },
      city: {
        label: 'City',
        type: 'select',
        initial: '',
        disabled: true,
        validation: {
          required: false
        },
        options: [
          {
            label: 'Select a city',
            value: ''
          }
        ],
      },
    },
  },
};
